import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getIntegrations } from '../lib/api';

const defaultIntegrations = [
  { name: 'Yemeksepeti' },
  { name: 'GetirYemek' },
  { name: 'TrendyolYemek' },
  { name: 'MigrosYemek' },
  { name: 'Netgsm' },
  { name: 'Paraşüt' },
  { name: 'Adisyo' },
  { name: 'SepetTakip' },
];

// Render colored text parts
const ColoredText = ({ parts, fallbackName }) => {
  if (!parts || parts.length === 0) {
    return <span>{fallbackName}</span>;
  }
  
  try {
    const parsed = typeof parts === 'string' ? JSON.parse(parts) : parts;
    return (
      <span>
        {parsed.map((part, index) => (
          <span key={index} style={{ color: part.color || 'inherit' }}>
            {part.text}
          </span>
        ))}
      </span>
    );
  } catch (e) {
    return <span>{fallbackName}</span>;
  }
};

export const IntegrationsSection = ({ audience }) => {
  const { t } = useTranslation();
  const [integrations, setIntegrations] = useState(defaultIntegrations);

  useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const response = await getIntegrations(audience);
        if (response.data && response.data.length > 0) {
          setIntegrations(response.data.filter(i => i.is_active));
        }
      } catch (err) {
        // Use defaults
      }
    };
    fetchIntegrations();
  }, [audience]);

  return (
    <section id="integrations" className="relative py-20 overflow-hidden" data-testid="integrations-section">
      {/* Background */}
      <div className="absolute inset-0 bg-background" />

      <div className="relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 px-4"
        >
          <p className="text-foreground/70 text-sm uppercase tracking-widest mb-2 font-medium">{t('integrations')}</p>
          <h3 className="font-heading font-semibold text-2xl text-foreground">
            {t('integrations_work')}
          </h3>
        </motion.div>

        <div className="relative">
          {/* Gradient masks */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" />

          <Marquee speed={30} pauseOnHover gradient={false}>
            {integrations.map((integration, index) => (
              <div
                key={index}
                className="mx-4 px-8 py-4 rounded-xl border border-border hover:border-border/80 transition-all duration-300"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
              >
                {integration.logo_url ? (
                  <img
                    src={integration.logo_url}
                    alt={integration.name}
                    className="h-8 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
                  />
                ) : (
                  <span className="font-heading font-semibold hover:opacity-80 transition-opacity whitespace-nowrap">
                    <ColoredText parts={integration.name_parts} fallbackName={integration.name} />
                  </span>
                )}
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
